export default __webpack_public_path__ + "styles/SeriesModifiedDate.2913ca56c8e7233e461f474c88edc8d9.css";